module.exports = __webpack_public_path__ + "img/quiz_mungjju_sad.2c1c90d7.png";